import { Fragment } from "react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { NativeSelect } from "@/components/common";
import { StagePill } from "@/components/leads/leadMeta";
import { CallLog, LeadActions } from "@/components/leads/LeadCallParts";
import { LocationTools } from "@/components/LocationTools";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const ANSWERS = [["lead_type", "Customer type"], ["phone", "Contact"], ["whatsapp", "WhatsApp"], ["email", "Email"], ["address", "Address"], ["area", "Area"],
  ["pincode", "PIN"], ["people", "People served"], ["varieties", "Interested in"], ["weekly_qty", "Per week"], ["monthly_qty", "Per month"],
  ["frequency", "Frequency"], ["credit_interest", "Weekly credit"], ["weekly_value", "Expected weekly value"], ["current_source", "Buys from now"],
  ["current_spend", "Monthly spend now"], ["priorities", "Matters most"], ["notes", "Requirements"], ["dob", "Date of birth"], ["wa_optin", "WhatsApp offers"], ["submitted_at", "Form filled"]];

export const LeadSheet = ({ lead, admin, reps, onClose, onChanged }) => {
  const update = async (body) => {
    try { const r = await api.put(`/leads/${lead.id}`, body); toast.success("Lead updated"); onChanged(r.data); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Sheet open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-lg" data-testid="lead-sheet">
        {lead && <>
          <SheetHeader>
            <SheetTitle className="font-display text-2xl text-[#0F382C]" data-testid="lead-sheet-name">{lead.name}</SheetTitle>
            <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground"><StagePill stage={lead.stage} testid="lead-sheet-stage" />Added {fmtDateTime(lead.created_at)}</div>
          </SheetHeader>
          <div className="mt-5 space-y-5">
            <LeadActions lead={lead} onSaved={onChanged} />
            <LocationTools who={lead} saveUrl={`/leads/${lead.id}/location`} method="put" onSaved={onChanged} prefix="lead" />
            <div className="grid grid-cols-2 gap-3">
              <label className="space-y-1 text-xs text-muted-foreground">Type
                <NativeSelect value={lead.segment || ""} onChange={(e) => update({ segment: e.target.value })} data-testid="lead-segment-select">
                  <option value="">Not set</option><option value="B2C">B2C · Home</option><option value="B2B">B2B · Business</option><option value="B2P">B2P · Stall / public place</option>
                </NativeSelect>
              </label>
              {admin && <label className="space-y-1 text-xs text-muted-foreground">Salesperson
                <NativeSelect value={lead.assigned_to || ""} onChange={(e) => e.target.value && update({ assigned_to: e.target.value })} data-testid="lead-assign-select">
                  <option value="">Unassigned</option>{reps.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
                </NativeSelect>
              </label>}
            </div>
            <CallLog lead={lead} onSaved={onChanged} />
            <div className="rounded-2xl border border-[#E7E2D6] bg-white p-4" data-testid="lead-answers">
              <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Form answers</div>
              <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm">
                {ANSWERS.filter(([k]) => lead[k]).map(([k, l]) => <Fragment key={k}><dt className="text-muted-foreground">{l}</dt><dd className="break-words" data-testid={`lead-answer-${k}`}>{lead[k]}</dd></Fragment>)}
              </dl>
            </div>
          </div>
        </>}
      </SheetContent>
    </Sheet>
  );
};
